import React from 'react';
import { Typography, Form, Button, Input, Icon, Popover } from 'antd'
import _sum from 'lodash/sum';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign } from '@fortawesome/free-solid-svg-icons/faRupeeSign';
import { accountNumberValidationRegex, ifscValidationRegex } from "../../../../app_methods";

const accountNumberValidator = (_rule, value, callback) => {
    if (!value) return callback();

    if (value.length < 3) {
      callback("Must be at least 3 characters long");
    } else if ((value.length > 26)) {
      callback("Must not exceed 26 characters");
    } else if(!(value.match(accountNumberValidationRegex()))) {
        callback("Invalid value for account number");
    } else {
        callback();
    }
  };

  const ifscValidator = (_rule, value, callback) => {
    if (!value) return callback();

    if (value.length == 0 ) {
      callback("Account IFSC is required");
    } else if ((value.length > 11)) {
      callback("Must not exceed 11 characters");
    } else if(!(value.match(ifscValidationRegex()))) {
        callback("Invalid value for IFSC");
    } else {
        callback();
    }
  };


const Remitters = (props) => {
    const { getFieldDecorator } = props.form;
    const remitters = props.form.getFieldValue('remitters');
    return (
        <div className="row">
            <div className="col-12">
                <div className="d-flex justify-content-between border-bottom align-items-center">
                    <Typography.Text level={4} style={{ fontSize: '14px', fontWeight: 'bold' }}>Authorized Source Accounts: <Popover
                    content="Accept money only from authorized source accounts."
                    placement="top"
                >
                    <Icon type="info-circle" />
                </Popover></Typography.Text>
                    <Button type="link" style={{ paddingRight: 0 }} icon="plus" onClick={props.addRemitter}>Add</Button>
                </div>
                <div className="splits mt-2">
                    {
                        (props.remitters || []).map((remitter, index) => {
                            return (
                                <div className="mb-2" key={index}>
                                    <div className="d-flex justify-content-between w-100 align-items-baseline">
                                        
                                        <Form.Item name="account_number"> {getFieldDecorator(`remitters[${index}].account_number`, {
                                            initialValue: remitter.account_number,
                                            rules: [
                                                {validator: (rule, value, callback) => { accountNumberValidator(rule, value, callback) }}
                                            ]
                                        })(
                                            <Input autoComplete='off' type="text" placeholder="Account Number" />
                                        )}
                                        </Form.Item>
                                        <Form.Item name="account_ifsc">{getFieldDecorator(`remitters[${index}].account_ifsc`, {
                                            initialValue: remitter.account_ifsc,
                                            rules: [
                                                {validator: (rule, value, callback) => { ifscValidator(rule, value, callback) }}
                                            ]
                                        })(
                                            <Input autoComplete='off' type="text" className="ml-2" placeholder="IFSC Code" />
                                        )}
                                        </Form.Item>
                                        <Form.Item className="ml-2">
                                            <Icon type="delete" style={{ fontSize: '150%', color: 'red' }} className="ml-2" onClick={props.removeRemitter.bind(this, index)} />
                                        </Form.Item>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}


export default Remitters;